import { CrownIcon } from '~/@mid_ui/icons/CrownIcon'
import { CrownPlusIcon } from '~/@mid_ui/icons/CrownPlusIcon'
import { ReinvestmentEliteIcon } from '~/@mid_ui/icons/ReinvestmentEliteIcon'

type Props = {
  title: string
  description: string
  buttonTitle?: string
  href?: string
  icon: React.ComponentType<any> // Return the component constructor
  backgroundColor: string
}

export function getVipTooltipConfig(
  blurTags: string[],
  getLandingPageLink: (path: string) => string
): Props {
  const isVip = blurTags.some((tag) => tag.startsWith('VIP'))
  const isIVip = blurTags.some((tag) => tag.startsWith('IVIP'))
  const isReinvestmentElite = blurTags.some((tag) => tag.startsWith('RE'))

  if (isVip)
    return {
      title: 'VIP Club',
      description:
        'Detail tejto investície je viditeľný len pre členov VIP Clubu',
      buttonTitle: 'Dozvedieť sa viac',
      href: getLandingPageLink('vip-club'),
      icon: CrownPlusIcon, // Component constructor
      backgroundColor: '#006EF0',
    }

  if (isIVip)
    return {
      title: 'Individuálna VIP Ponuka',
      description:
        'Táto ponuka je viditeľná len pre konkrétneho člena VIP Clubu',
      icon: CrownPlusIcon, // Component constructor
      backgroundColor: '#006EF0',
    }

  if (isReinvestmentElite)
    return {
      title: 'Reinvestment Elite',
      description:
        'Detail tejto investície je viditeľný len pre členov Reinvestment Elite',
      buttonTitle: 'Dozvedieť sa viac',
      href: getLandingPageLink('reinvestment-elite'),
      icon: ReinvestmentEliteIcon, // Component constructor
      backgroundColor: '#7800F0',
    }

  return {
    title: 'Premium Club',
    description:
      'Detail tejto investície je viditeľný len pre členov Premium Clubu',
    buttonTitle: 'Dozvedieť sa viac',
    href: getLandingPageLink('premium-club'),
    icon: CrownIcon, // Component constructor
    backgroundColor: '#006EF0',
  }
}
